var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99935 2.49984C4.68564 2.49984 1.99935 5.18613 1.99935 8.49984C1.99935 11.8135 4.68564 14.4998 7.99935 14.4998C11.3131 14.4998 13.9993 11.8135 13.9993 8.49984C13.9993 5.18613 11.3131 2.49984 7.99935 2.49984ZM0.666016 8.49984C0.666016 4.44975 3.94926 1.1665 7.99935 1.1665C12.0494 1.1665 15.3327 4.44975 15.3327 8.49984C15.3327 12.5499 12.0494 15.8332 7.99935 15.8332C3.94926 15.8332 0.666016 12.5499 0.666016 8.49984Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00065 5.1665C8.36884 5.1665 8.66732 5.46498 8.66732 5.83317V8.49984C8.66732 8.86803 8.36884 9.1665 8.00065 9.1665C7.63246 9.1665 7.33398 8.86803 7.33398 8.49984V5.83317C7.33398 5.46498 7.63246 5.1665 8.00065 5.1665Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33398 11.1667C7.33398 10.7985 7.63246 10.5 8.00065 10.5H8.00732C8.37551 10.5 8.67398 10.7985 8.67398 11.1667C8.67398 11.5349 8.37551 11.8333 8.00732 11.8333H8.00065C7.63246 11.8333 7.33398 11.5349 7.33398 11.1667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.f2b81bc34cf59e2580e264de4fa640cf.svg";
export { ForwardRef as ReactComponent };